import React, { useEffect } from "react";
import { IframeOrFullPageWrapper } from "components/Container";
import { FLOW_STATE } from "utils";
import { useFlowConfig } from "flows/hooks";

import Transaction from "./TxnDetailsContainer";

/**
 * TxnDetails
 * @description
 * Page that wraps the Transaction component (more detail there).
 * Main bit of this component is to pull the request transactionId from
 * the session context so we can keep that component cleaner for re-use in TxnHistory
 */
export default function TxnDetails({ onReady, onUpdate, onComplete, onError }) {
  const { hideExitButtons, transactionId } = useFlowConfig();

  useEffect(() => {
    // On mount, we call `onReady` right away, since this flow has its own way
    // of handling loading states.
    onReady({ state: FLOW_STATE.READY });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IframeOrFullPageWrapper includeTosAndPrivacy>
      <Transaction
        transactionId={transactionId || null}
        onUpdate={onUpdate}
        onComplete={onComplete}
        onError={onError}
        hideExitButton={!!hideExitButtons}
      />
    </IframeOrFullPageWrapper>
  );
}
